import {
  ZapisPredbeznehoStanoviskaApi,
} from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import Uuid from '../../model/Uuid';

const client = new ZapisPredbeznehoStanoviskaApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const savePredbezneStanoviskoClient = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: Uuid,
  file: File,
  headers?: object,
):
  Promise<ClientResponse<void>> => {
  const { status } = await client.savePredbezneStanovisko(type, year, index, pracovnyKrokId, file, headers);
  return { responseCode: status };
};
